import React, { useEffect, useRef } from 'react';

const ModernMap = () => {
    const mapRef = useRef(null);

    useEffect(() => {
        const initMap = () => {
            if (!mapRef.current || !window.google) return;

            const manhattanCenter = { lat: 40.7831, lng: -73.9712 };

            const map = new window.google.maps.Map(mapRef.current, {
                center: manhattanCenter,
                zoom: 13,
                disableDefaultUI: true, // Disable default UI controls
                gestureHandling: 'none', // Disable map interactions (panning, zooming)
                backgroundColor: '#f5f5f5',
                styles: [
                    {
                        featureType: 'all',
                        elementType: 'labels',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#e9e9e9' }],
                    },
                    {
                        featureType: 'landscape',
                        elementType: 'geometry',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#ffffff' }, { weight: 1 }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            });
        };

        if (window.google && window.google.maps) {
            initMap();
        } else {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
            script.async = true;
            script.defer = true;
            script.addEventListener('load', initMap);
            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, []);

    return (
        <div
            ref={mapRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%', // Ensure the map takes up the full height
                opacity: 1,
                zIndex: 0,
            }}
        />
    );
};

export default ModernMap;
